
import House2 from "../../../assets/duotone/House2.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function House2Icon({ className, dataTestid = "House2Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <House2 data-testid={dataTestid} className={classes} {...rest} />
  );
}
